import { compose } from 'redux';
import { WithFetchDatasFromCMS, WithFetchDatasFromCMSInputProps, WithCMSSEO } from 'modules/shared-cms/hocs';

import { HomeAltProps } from './home-alt-type';
import { QUERY } from './home-alt-query';
import { HomeAltLoader } from './home-alt-loader';

const enhancer = compose<React.ComponentType<WithFetchDatasFromCMSInputProps>>(
    WithFetchDatasFromCMS<HomeAltProps>(QUERY, HomeAltLoader, 'queryCatalogueLandingV2Contents'),
    WithCMSSEO(),
);
export default enhancer;
